import React, { useState } from "react";

type TooltipProps = {
  delay?: number;
  children?: any;
  className?: string;
  //   direction?: string;
  content: any;
};

const Tooltip = (props: TooltipProps) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className="tooltip-container"
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Container */}
      {props.children}
      {active && (
        // <div className={`tooltip-tip ${props.direction || "top"}`}>
        <div className="tooltip-tip top">
          {/* Text inside tooltip */}
          {props.content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
